export const TOGGLE_VIEWS = {
	images:{
		name:"Images",
		title:"Images",
		icon: "assetImage",
		value:"Image",
	},
	richloads:{
		name:"Richloads",
		title:"Richloads",
		icon: "assetRichload",
		value:"Richload",
	},
	videos:{
		name:"Videos",
		title:"Videos",
		icon: "assetVideo",
		value:"Video",
	},
	audios: {
		name: "Audio",
		title: "Audio",
		icon: "fas fa-volume",
		value: "Audio",
	},
	texts:{
		name:"Text",
		title:"Text",
		icon:"assetText",
		value:"Text",
	},
	afterEffects:{
		name:"After Effects",
		title:"After Effects Packages",
		icon:"fas fa-file-zipper",
		value:"AfterEffects",
	},
};
